<div *ngIf="isCustomConnection; else defaultView" class="orbitax-connect-custom-connection-centered">
  <app-platform-tool-dialog-definition-container
    [api]="api"
    [platformDialogId]="platformDialogId"
    [platformDialogCommand]="refreshCommand"
    (formValueChange)="onFormValueChanged($event)"
    (dialogInit)="onDialogInit($event)"
  ></app-platform-tool-dialog-definition-container>
</div>

<ng-template #defaultView>
  <app-platform-tool-dialog-definition-container
    [api]="api"
    [platformDialogId]="platformDialogId"
    [platformDialogCommand]="refreshCommand"
    (formValueChange)="onFormValueChanged($event)"
    (dialogInit)="onDialogInit($event)"
  ></app-platform-tool-dialog-definition-container>
</ng-template>
